import { graphql } from "gatsby"
import * as React from "react"
import Layout from "../components/layout"
import Projects from "../components/projects"
import Spacer from "../components/spacer"
import Title from "../components/title"
import Seo from "../components/seo"
const WorkPage = ({ data }) => {


  return (
    <Layout optimised={false}>
      <Seo title="Work" />
      <Spacer />
      <Spacer className='m-hide' />
      <Title text='Work' className='h1' />
      <Spacer className='m-hide' />
      <Spacer />
      <Projects groupByYear={data.page.groupByYear} categories={data.allDatoCmsCategory.nodes} projects={data.allDatoCmsProject.nodes} />
      <Spacer />
      <Spacer className='m-hide' />
    </Layout>
  )
}
export default WorkPage

export const query = graphql`
  query work {
    allDatoCmsCategory {
      nodes {
        name
        id
      }
    }
    page:datoCmsWorkPage{
      groupByYear
      nextPage{
        ...NextPage
      }
    }
    allDatoCmsProject {
      nodes {
        name
        year
        slug
        comingSoon
        scope
        projectColor {
          hex
        }
        category {
          id
          name
        }
        featuredVideo
        hoverVideoUrl
        featuredImage {
          gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 1200)
        }
        hoverImage {
          gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 1200)
        }
        mThumbnail:featuredImage {
          gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 800)
        }
        thumbnail:featuredImage {
          gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 200)
        }
      }
    }
  }
`
